<template>
	<div>
		<v-textarea rows="20" v-model="json" label="json" v-on:blur="updateJson"></v-textarea>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: "EditSurveyJson", 
		data: () =>{
			return {
				json: '',
			}
		},
		props: {
			elements: {type: Array },
			surveyProperties: {type: Object }
		},
		methods: {
			updateJson(){
				let surveyObject = JSON.parse( this.json );
				let elements = {...surveyObject.elements}
				delete surveyObject.elements
				let surveyProperties = surveyObject;
				this.$emit("updated", {elements, surveyProperties}) 
			}
		},
		created: function(){
			let surveyObject = {...this.surveyProperties};
			surveyObject.elements = this.elements;	
			this.json = JSON.stringify(surveyObject); 
		}
	}
</script>